<template>
    <div v-if="isLoading" class="progress position-fixed top-0 w-100 rounded-0" style="z-index: 9999;height: .35rem">
        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
    </div>
    <template v-if="userCheckDone && permissionsFetched && settingsLoaded">
        <component :is="layout" v-if="layout">
            <router-view/>
        </component>
        <router-view v-else/>
    </template>
    <notifications/>
    <!--  <loader v-if="false" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" disableScrolling="false" name="circular"></loader>-->
</template>

<script>
import authService from "@/services/auth.service";

import LayoutDefault from './components/layouts/Default'
import LayoutAuth from './components/layouts/Auth'
import LayoutDashboard from './components/layouts/Dashboard'
import LayoutOperatorDashboard from './components/layouts/OperatorDashboard'
import {initializePusher, notifyError} from "@/helpers";
import AclService from "@/services/acl.service";
import AuthService from "@/services/auth.service";
import TranslationService from "./services/translation.service";
import SystemSetupService from "@/services/system-setup.service";
import {dateTimeFormats} from "./i18n";

export default {
    name: 'App',
    data() {
        return {
            userCheckDone: false,
            permissionsFetched: false,
            timer: null,
        }
    },
    components: {
        LayoutDefault,
        LayoutAuth,
        LayoutDashboard,
        LayoutOperatorDashboard
    },
    computed: {
        // currentUser() {
        //   return this.$store.state.auth.user;
        // },
        layout() {
            return (this.$route.meta.layout)
        },
        isLoading() {
            return this.$store.state.loader.count > 0;
        },
        settingsLoaded() {
            return this.$store.state.system.loaded;
        },
    },
    methods: {
        pingServer() {
            let now = Date.now();
            if (this.$store.state.loader.lastHit <= now - 60 * 2000) {
                AuthService.ping().catch(() => {});
            }
        },
        async checkUserLoggedIn() {
            await this.$router.isReady();
            if (this.$route.query.lang) {
                this.$store.commit('system/setLanguage', this.$route.query.lang);
            }
            await this.loadLanguage();
            if (this.$route.name === 'oauth2-callback') {
              this.userCheckDone = true;
              return;
            }
            let token = this.$route.query.token;
            if (!token) {
                token = JSON.parse(localStorage.getItem('user'))?.token;
            }
            if (token) {
                return authService.getUserDataByToken(token).then(d => {
                    this.$store.commit('auth/loginSuccess', d);
                    initializePusher();
                    let query = {...this.$route.query}
                    delete query.token;
                    this.$router.replace({path: this.$route.path, query});
                }).catch((e) => {
                    if (e.response) {
                        localStorage.removeItem('user');
                        if (this.$route.name !== 'LoginForm') {
                          this.$router.replace({name: 'LoginForm'});
                        }
                    } else {
                        notifyError(e);
                    }
                }).finally(() => {
                    this.userCheckDone = true;
                })
            } else {
                this.userCheckDone = true;
            }
        },
        async checkPermissions() {
            AclService.fetchUserRolesAndMenus().then(d => {
                this.$store.dispatch('auth/rolesAndMenus', d.data)
            }).catch(() => {}).finally(() => {
                this.permissionsFetched = true;
            })
        },
        async loadLanguage() {
            let lang = this.$store.state.system.lang;
            TranslationService.getTranslationForLang(lang).then(d => {
                let msgList = d.contents;
                this.$i18n.setLocaleMessage(lang, msgList);
                this.$i18n.setDateTimeFormat(lang, dateTimeFormats);
                this.$i18n.locale = lang;
            }).catch(e => notifyError(e));
            if (lang) {
                document.documentElement.lang = lang;
            }
        },
        async fetchSettings() {
            return SystemSetupService.getSystemSetup().then(response => {
                this.$store.commit('system/setSettings', response.data.data);
            }).catch(e => notifyError(e));
        },
    },
    mounted() {
        //this.fetchSettings();
        this.checkUserLoggedIn().finally(() => {
            this.checkPermissions();
            this.timer = setInterval(this.pingServer, 60 * 2000); // every 2 minutes.
        });
    },
    beforeUnmount() {
        clearInterval(this.timer);
    },
    watch: {
        $route (){
            //this.show = false;
            this.fetchSettings();
        }
    }
}

</script>
